
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-use",
      function () {
        return require("private-next-pages/terms-of-use.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-of-use"])
      });
    }
  